import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/@core/services/notification.service';
import { API_SERRI_CREATE_TEMPLATE, PROJECT_API_KEY } from 'src/@core/services/util/api.endpoints';

@Component({
  selector: 'hour4u-admin-serri-create-template-dialog',
  templateUrl: './serri-create-template-dialog.component.html',
  styleUrls: ['./serri-create-template-dialog.component.scss']
})
export class SerriCreateTemplateDialogComponent {
  entityId: string = '';
  name: string = '';
  label: string = '';
  category: string = 'UTILITY';
  type: string = 'TEXT';
  language: string = 'English';
  text: string = '';
  sampleText: string = '';
  headerText: string = '';
  footerText: string = '';
  submitting: boolean = false;
  selectedSerriPhone: string = '';

  constructor(
    private dialogRef: MatDialogRef<SerriCreateTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { entityId?: string; selectedSerriPhone?: string },
    private http: HttpClient,
    private notify: NotificationService
  ) {
    this.entityId = (data && data.entityId) || '';
    this.selectedSerriPhone = (data && data.selectedSerriPhone) || '';
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    if (!API_SERRI_CREATE_TEMPLATE) {
      this.notify.showMessage('Serri create-template API is not configured.', 5000);
      return;
    }
    if (!this.entityId) {
      this.notify.showMessage('Entity ID is missing.', 3000);
      return;
    }
    if (!this.selectedSerriPhone || !this.selectedSerriPhone.trim()) {
      this.notify.showMessage('WhatsApp phone number is missing.', 3000);
      return;
    }
    if (!this.name.trim() || !this.label.trim() || !this.text.trim() || !this.sampleText.trim()) {
      this.notify.showMessage('Name, label, body text, and sample text are required.', 3000);
      return;
    }

    this.submitting = true;

    const body = {
      entity_id: this.entityId,
      whatsapp_phone_number: this.selectedSerriPhone.trim(),
      name: this.name.trim(),
      label: this.label.trim(),
      category: this.category,
      type: this.type,
      language: this.language.trim() || 'English',
      text: this.text,
      sample_text: this.sampleText,
      header_text: this.headerText || '',
      footer_text: this.footerText || '',
      buttons: [] as any[]
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true',
    });

    // Keep auth header consistent with other project APIs if jwtToken exists
    const authToken = localStorage.getItem('jwtToken');
    const finalHeaders = authToken ? headers.set('Authorization', `Bearer ${authToken}`) : headers;

    this.http.post(API_SERRI_CREATE_TEMPLATE, body, { headers: finalHeaders }).subscribe({
      next: (res: any) => {
        this.submitting = false;
        if (res && (res.success === true || res.success === undefined)) {
          this.notify.showMessage(res.message || 'Template created successfully', 3000);
          this.dialogRef.close({ success: true });
        } else {
          this.notify.showMessage((res && res.message) || 'Template create failed', 4000);
        }
      },
      error: (err) => {
        this.submitting = false;
        const msg = err.error && err.error.message ? err.error.message : 'Failed to create template';
        this.notify.showMessage(msg, 5000);
      }
    });
  }
}
